import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faDollarSign,
  faArrowTrendUp,
  faShoppingCart,
  faBullseye,
  faCreditCard,
  faBox,
} from '@fortawesome/free-solid-svg-icons';

export const METRIC_IDS = {
  GROSS_SALES: 'grossSales',
  NET_SALES: 'netSales',
  TOTAL_REVENUE: 'totalRevenue',
  TIPS: 'tips',
  ORDER_COUNT: 'orderCount',
  ITEMS_SOLD: 'itemsSold',
} as const;

export const METRIC_COLORS = {
  GROSS_SALES: '#10b981',
  NET_SALES: '#3b82f6',
  TOTAL_REVENUE: '#8b5cf6',
  TIPS: '#f59e0b',
  ORDER_COUNT: '#14b8a6',
  ITEMS_SOLD: '#06b6d4',
} as const;

export const METRIC_ICONS: Record<string, IconDefinition> = {
  [METRIC_IDS.GROSS_SALES]: faDollarSign,
  [METRIC_IDS.NET_SALES]: faArrowTrendUp,
  [METRIC_IDS.TOTAL_REVENUE]: faCreditCard,
  [METRIC_IDS.TIPS]: faBullseye,
  [METRIC_IDS.ORDER_COUNT]: faShoppingCart,
  [METRIC_IDS.ITEMS_SOLD]: faBox,
};

export const CATEGORY_TABLE_COLUMNS = [
  { title: 'Category', dataIndex: 'name', key: 'name' },
  { title: 'Revenue', dataIndex: 'revenue', key: 'revenue', align: 'right' as const },
  { title: 'Items Sold', dataIndex: 'itemsSold', key: 'itemsSold', align: 'right' as const },
  { title: 'Orders', dataIndex: 'orders', key: 'orders', align: 'right' as const },
];

export const ITEM_TABLE_COLUMNS = [
  { title: 'Item Name', dataIndex: 'name', key: 'name' },
  { title: 'Revenue', dataIndex: 'revenue', key: 'revenue', align: 'right' as const },
  { title: 'Quantity', dataIndex: 'quantity', key: 'quantity', align: 'right' as const },
  { title: 'Price', dataIndex: 'price', key: 'price', align: 'right' as const },
];

export const EMPTY_STATE_MESSAGES = {
  DAILY_BREAKDOWN: 'No daily breakdown data available for this week.',
  CATEGORY_SALES: 'No category sales data available for this week.',
  ITEM_SALES: 'No item sales data available for this week.',
} as const;

export const REPORT_TYPE = {
  WEEKLY: 'weekly',
} as const;

export const addCommasInPrices = (value: number | string): string => {
  return (parseFloat(String(value)) || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
